export default __webpack_public_path__ + "static/media/uploadCloud.66093ff2.png";